import { render, staticRenderFns } from "./shopping-bag.vue?vue&type=template&id=ce29b4a8&"
import script from "./shopping-bag.vue?vue&type=script&lang=js&"
export * from "./shopping-bag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports